export default {
  getUsersData: (state) => state.usersData,
  getUserReputationScores: (state) => state.userReputationScores,
};
